export const GET_MEMBERSHIP_PLANS = "GET_MEMBERSHIP_PLANS"

export const SET_MEMBERSHIP_PLANS = "SET_MEMBERSHIP_PLANS"